




















import { Component, Vue } from "vue-property-decorator";
import LineTitle from "@/basics/title/LineTitle.vue";
import NoData from "@/basics/boxes/NoData.vue";
import RoomsListComponent from "@/components/list/RoomsList.vue";
import {
  OneAppUserData,
  ONE_APP_USER,
  OneAppUserVariables
} from "@/graphql/query/appUser/one";
import { USER_ME, UserMeData } from "@/graphql/query/user/me";

export interface AppUserBuilding {
  id: string;
  name: string;
  buildings: {
    id: string;
    name: string;
    rooms: {
      id: string;
      name: string;
    }[];
  }[];
  start: number;
  end: number;
  expired: boolean;
  prePeriod: boolean;   
}

@Component({
  components: {
    LineTitle,
    RoomsListComponent,
    NoData
  },
  apollo: {
    appUser: {
      query: ONE_APP_USER,
      variables(): OneAppUserVariables {
        return { id: this.$apollo.vm.$route.params.appUserId };
      },
      update(data: OneAppUserData): AppUserBuilding {
        return data.appUser;
      }
    },
    groupId: {
      query: USER_ME,
      update(data: UserMeData): string {
        return data.me.group.id;
      }
    }    
  }
})
export default class AppAccountRooms extends Vue {
  appUser: AppUserBuilding | null = null;
  groupId: string = "";

  mounted() {
    if (this.appUser) {
      this.appUser = null;
      this.$apollo.queries.appUser.refetch();
    }
  }
}
